import React, { useEffect, useState } from 'react';
import TableHeading from '../../../Components/common/table/Tableheading';
import { showData } from '../../../Utils/APIs/commonShowAPI';
import { insertData } from '../../../Utils/APIs/commonInsertAPI';

export const VehicleList = () => {
    const [vehicleResponse, setVehicleResponse] = useState(null);
    const headingList = [
        "Sr No",
        "Vehicle No",
        "Driver Name",
        "Driver Contact",
        "Tracking Status",
        "#",
        "#"
    ];
    const [vehicleList, setVehicleList] = useState([]);
    useEffect(() => {
        const vehicleData = async () => {
            await showData("track/vehicleList", setVehicleList);
        };
        vehicleData();
    }, [vehicleResponse]);

    const [resendSMSResponse, setResendSMSResponse] = useState(null);
    
    const resendSMS = (contact) => async () => {
        await insertData("track/resendTrackingSMS_Call_for_Vehicle", setResendSMSResponse, { driverContact: contact });
    }
    useEffect(() => {
        if (resendSMSResponse) {
            alert(resendSMSResponse);
            setResendSMSResponse(null);
        }
    }, [resendSMSResponse]);

    
    const deleteVehicle = (vehicleId) => async () => {
        const confirmDelete = window.confirm("Are you sure you want to delete this vehicle?");
        if (confirmDelete) {
            await insertData("track/untrackVehicle", setVehicleResponse, { vehicleId });
        }
    }
    useEffect(() => {
        if (vehicleResponse) {
            alert(vehicleResponse);
            setVehicleResponse(null);
            const vehicleData = async () => {
                await showData("track/vehicleList", setVehicleList);
            };
            vehicleData();
        }
    }, [vehicleResponse]);
    const re_track_Vehicle = (vehicleId) => async() =>{
        const confirmReTrack = window.confirm("Are you sure you want to  this vehicle?");
        if(confirmReTrack){
            await insertData("track/vehicle-re-track", setVehicleResponse, { vehicleId });
        }
    }

    return (
        <div className="flex w-full h-full bg-white">
            <div className="w-full overflow-x-auto h-[calc(100vh-11rem)]">
                <table className="min-w-full h-full border-2 divide-y divide-gray-200 text-center overflow-scroll">
                    <TableHeading list={headingList} />
                    <tbody className="bg-white divide-y divide-gray-200">
                        {vehicleList.map(({ _id, vehicleNumber, driverName, driverContact, status, consentStatus }, index) => (
                            <tr className="hover:bg-gray-100 cursor-pointer" key={_id}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{++index}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vehicleNumber}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{driverName}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{driverContact}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{consentStatus}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <button className="text-blue-600 hover:text-blue-900" onClick={resendSMS(driverContact)}>Resend SMS</button>
                                </td>
                                {<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {status ? <button className="text-red-600 hover:text-red-900" onClick={deleteVehicle(_id)}>Untrack{status}</button> :
                                    <button className="text-green-600 hover:text-green-900" onClick={re_track_Vehicle(_id)}>Re-track</button>}
                                </td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
